module.exports = __webpack_public_path__ + "media/images/icons/datatable/sort_asc-da7ee0eceb6a70b9954b7fb36538648e.png";